export default __webpack_public_path__ + "static/media/Translate.ed31eedf.svg";